import AuthButton from './AuthButton';
import AuthHeading from './AuthHeading';

export { AuthButton, AuthHeading };
